import Parse from 'parse';

export enum PipelineFields {
  TABLE = "Pipeline",
  NAME = "name",
  DESCRIPTION = "description",
  ENV = "env",
}

export class Pipeline extends Parse.Object {
  static className = PipelineFields.TABLE;

  constructor() {
    super(Pipeline.className);
  }

  set name(value: { [key: string]: string }) {
    this.set(PipelineFields.NAME, value);
  }
  get name(): { [key: string]: string } {
    return this.get(PipelineFields.NAME) ?? {};
  }

  get description(): { [key: string]: string } {
    return this.get(PipelineFields.DESCRIPTION) ?? {};
  }

  get env(): "cloud" | "edge" {
    return this.get(PipelineFields.ENV);
  }

  set env(value: "cloud" | "edge") {
    this.set(PipelineFields.ENV, value);
  }
}
